import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-loop",
  "use": "icon-loop-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-loop\">\r\n  <path d=\"M17 2l4 4-4 4\" />\r\n  <path d=\"M3 11V9a4 4 0 0 1 4-4h14\" />\r\n  <path d=\"M7 22l-4-4 4-4\" />\r\n  <path d=\"M21 13v2a4 4 0 0 1-4 4H3\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol